import { render } from "./TheAdminHome.vue?vue&type=template&id=55774b2c&ts=true"
import script from "./TheAdminHome.vue?vue&type=script&lang=ts"
export * from "./TheAdminHome.vue?vue&type=script&lang=ts"

import "./TheAdminHome.vue?vue&type=style&index=0&id=55774b2c&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__